import React, { useState, useMemo, useEffect } from "react";
import { Modal } from "react-bootstrap";
// import Select from 'react-select'
import countryList from "react-select-country-list";

const AddressModal = ({
  show,
  onHide,
  title,
  data,
  onchange,
  onSubmit,
  buttonTitle,
}) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const country = countryList().getData();
    setOptions(country);
  }, []);

  return (
    <div>
      <Modal show={show} onHide={onHide}>
        <Modal.Header className="border-0 pb-0" closeButton></Modal.Header>
        <Modal.Body className="px-4 pb-4 d-flex flex-column justify-content-between">
          <div>
            <h4 className="fw-bold fs_22 color_darkgray">{title}</h4>
            <div className="">
              <div className="row">
                <div>
                  <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                    Full Name
                  </label>
                  <input
                    name="name"
                    value={data?.name}
                    onChange={onchange}
                    type="text"
                    className="form-control"
                  />
                </div>
                <div>
                  <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                    Phone Number
                  </label>
                  <input
                    name="phoneNumber"
                    value={data?.phoneNumber}
                    onChange={onchange}
                    type="text"
                    className="form-control"
                  />
                </div>
                <div className="my-2">
                  <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                    Address
                  </label>
                  <textarea
                    name="address"
                    value={data?.address}
                    onChange={onchange}
                    className="form-control"
                    cols="30"
                    rows="2"
                  ></textarea>
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <div className="col-6">
                    <div className="pe-2">
                      <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                        City
                      </label>
                      <input
                        name="city"
                        value={data?.city}
                        onChange={onchange}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="ps-2">
                      <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                        Country
                      </label>
                      <select
                        value={data.country}
                        onChange={onchange}
                        className="form-select"
                        name="country"
                      >
                        {options?.map(({ label }) => {
                          return (
                            <option value={label} key={label}>
                              {label}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <div className="col-6">
                    <div className="pe-2">
                      <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                        Pin Code
                      </label>
                      <input
                        name="pincode"
                        value={data.pincode}
                        onChange={onchange}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="ps-2">
                      <label className="mb-2 fs_11 fw-semibold" htmlFor="">
                        State
                      </label>
                      <input
                        name="state"
                        value={data?.state}
                        onChange={onchange}
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mt-3">
            <button
              onClick={onSubmit}
              className="tab_btn w-100 border-0 py-1 rounded-2 fs_21 fw-semibold ff_inter text-white"
              type="submit"
            >
              {buttonTitle}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddressModal;
